import { message } from 'antd'
import { Macro } from 'Model'
import ConfigQuery from 'Model/ConfigQuery'
import cuid from 'cuid'

export save = (nodeId = cuid(), state) ->
  try
    macro = await new ConfigQuery()
      .type(Macro)
      .restrict(nodeId)
      .first(Macro)
  catch
    macro = new Macro(nodeId)

  macro.set('name', state.name)
    .set('configBlob', prepareConfig(state, nodeId), { dataType: 'json' })
    .save({ commitMessage: 'Updated form configuration.' })

registerQuery = (q, list) ->
  return undefined unless q
  key = cuid()
  list.push({
    id: key
    data:
      query: q
  })
  key

prepareConfig = (state, nodeId) ->
  queries = []
  {
    key: nodeId
    title: state.name
    hidden: state.isHidden
    component: 'sequenced_form'
    formSequence:
      onSave:
        confirmation: state.confirmationMessage
        node:
          typeNode: state.typeNode
          graph: state.graph
      formFields: _.values(state.fieldData)
        .filter(({ key }) -> key? && key isnt '')
        .map((field) ->
          {
            formItem: field.key
            formItemLabel: field.label
            formItemType: field.type
            formItemRules: field.rules
            formitemdefaultvalue: field.default
            options: field.options
            derivedData: field.derivedData && {
              field.derivedData...
              querySource: registerQuery(field.derivedData?.query, queries)
              queryLabelAttr: field.derivedData?.attr
            }
            save: field.save
            config: field.config
          }
        )
      queries: queries
      sequence: state.steps
        .map((fields) ->
          fields
            .filter((field) ->
              !state.fieldData[field].key && field = _.findKey(state.fieldData, ({ key }) -> key is field)
              definedAndNotEmpty(state.fieldData[field]?.key) and
              definedAndNotEmpty(state.fieldData[field]?.type)
            ).map((field) ->
              state.fieldData[field].key
            )
        ).filter((step) -> step.length > 0)
        .map((fields) -> { fields })
  }

definedAndNotEmpty = (toTest) ->
  toTest? and toTest isnt ''

export load = (nodeId) ->
  return unless nodeId
  (await Macro.load(nodeId)).mapDbConfigToState()
